
import BlogText3Section from '~/components/Common/Blog/BlogText3Section'

export default {
    name: 'Bond',
    components: { BlogText3Section },
}
